import { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Statistic,
  Select,
  DatePicker,
  Table,
  Tag,
  Progress,
  Tooltip,
  Spin,
  Empty,
  message,
  Button,
  Modal,
} from "antd";
import {
  BookOutlined,
  UserOutlined,
  CalendarOutlined,
  TrophyOutlined,
  WarningOutlined,
  ClockCircleOutlined,
  RiseOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SettingOutlined,
  CrownOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
  Area,
  AreaChart,
  ComposedChart,
} from "recharts";
import axios from "axios";
import { BaseUrl, AssesmentUrl } from "../Constants/Constants";
import moment from "moment";
import "./CareerDevelopmentDashboard.css";

const { RangePicker } = DatePicker;
const { Option } = Select;

// Color palette for charts
const CHART_COLORS = {
  completed: "#52c41a",
  pending: "#faad14",
  notStarted: "#ff4d4f",
  learningCompleted: "#722ed1",
  primary: "#1890ff",
  secondary: "#722ed1",
  accent: "#13c2c2",
};

const COLORS = [
  "#52c41a",
  "#faad14",
  "#ff4d4f",
  "#1890ff",
  "#722ed1",
  "#13c2c2",
];

const CareerDevelopmentDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [timeFilter, setTimeFilter] = useState("month"); // daily, weekly, monthly
  const [dateRange, setDateRange] = useState([
    moment().startOf("month"),
    moment().endOf("month"),
  ]);

  // Summary Card Data
  const [summaryData, setSummaryData] = useState({
    totalCourses: 0,
    totalEmployeesEnrolled: 0,
    coursesAssignedThisMonth: 0,
  });

  // Course Analytics Data
  const [courseAnalytics, setCourseAnalytics] = useState({
    completed: 0,
    pending: 0,
    notStarted: 0,
  });

  // Course List for Top Performers Filter
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);

  // Employee Learning Insights
  const [topPerformers, setTopPerformers] = useState([]);
  const [courseTopPerformers, setCourseTopPerformers] = useState([]);
  const [employeesRequiringAttention, setEmployeesRequiringAttention] =
    useState([]);

  // Chart Data
  const [courseCompletionData, setCourseCompletionData] = useState([]);
  const [completionTrendData, setCompletionTrendData] = useState([]);
  const [completionStatusData, setCompletionStatusData] = useState([]);
  const [employeeStatusData, setEmployeeStatusData] = useState([]);
  const [learningHoursByTeam, setLearningHoursByTeam] = useState([]);
  const [courseAssignmentsTimeline, setCourseAssignmentsTimeline] = useState(
    [],
  );
  const [teamGoals, setTeamGoals] = useState([]);

  // const [selectedCompletionCourse, setSelectedCompletionCourse] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedCompletionGroup, setSelectedCompletionGroup] = useState(null);

  const [selectedTopPerformerGroup, setSelectedTopPerformerGroup] = useState(
    [],
  );
  const [groupTopPerformers, setGroupTopPerformers] = useState([]);

  const [coursePieData, setCoursePieData] = useState([]);
  const [courseTotal, setCourseTotal] = useState(0);
  const [loadingCourseAnalytics, setLoadingCourseAnalytics] = useState(false);
  const [appliedTopPerformerGroup, setAppliedTopPerformerGroup] = useState([]);

  useEffect(() => {
    fetchDashboardData();
    fetchCoursesList();
    fetchGroupList();
  }, [timeFilter, dateRange]);

  // useEffect(() => {
  //   if (!selectedTopPerformerGroup || selectedTopPerformerGroup.length === 0) {
  //     setGroupTopPerformers([]);
  //     return;
  //   }

  //   //calls single group top performers API
  //   if (selectedTopPerformerGroup.length === 1) {
  //     fetchGroupTopPerformers(selectedTopPerformerGroup[0]);
  //   } else {
  //     //calls multiple group top performers API
  //     fetchMultipleGroupTopPerformers(selectedTopPerformerGroup);
  //   }
  // }, [selectedTopPerformerGroup]);

  // Fetch all courses for the dropdown filter

  useEffect(() => {
    if (!appliedTopPerformerGroup || appliedTopPerformerGroup.length === 0) {
      setGroupTopPerformers([]);
      return;
    }

    fetchGroupTopPerformers(appliedTopPerformerGroup);
  }, [appliedTopPerformerGroup]);

  const fetchCoursesList = async () => {
    try {
      const res = await axios.get(`${BaseUrl}career-development/courses`, {
        withCredentials: true,
      });

      if (res.data && Array.isArray(res.data)) {
        setCourses(res.data);
      }
    } catch (error) {
      console.error("Error fetching courses list:", error);
      setCourses([]);
    }
  };

  //fetches the group list

  const fetchGroupList = async () => {
    try {
      const res = await axios.get(`${BaseUrl}career-development/getGroups`, {
        withCredentials: true,
      });

      if (res.data && Array.isArray(res.data)) {
        setGroups(res.data);
      }
    } catch (error) {
      console.error("Error fetching the groups lists", error);
    }
  };

  // Fetch top performers for a specific course
  // const fetchCourseTopPerformers = async (courseId) => {
  //   try {
  //     if (!courseId) {
  //       setCourseTopPerformers([]);
  //       return;
  //     }

  //     // Call career_dev_course_ranklist API with course_id
  //     const res = await axios.get(
  //       `${AssesmentUrl}career_dev_course_ranklist?course_id=${courseId}`,
  //       { withCredentials: true }
  //     );

  //     console.log('Course Top Performers Response:', res.data);

  //     if (res.data.status === 200 && res.data.data && Array.isArray(res.data.data)) {
  //       const transformedData = res.data.data.map((user) => ({
  //         key: user.user_id,
  //         rank: user.rank,
  //         name: user.username,
  //         score: user.score,
  //       }));
  //       setCourseTopPerformers(transformedData);
  //     } else {
  //       setCourseTopPerformers([]);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching course top performers:', error);
  //     setCourseTopPerformers([]);
  //   }
  // };

  const fetchGroupTopPerformers = async (groupIds) => {
    try {
      setLoading(true);

      // Send all group_ids as array in request body
      const res = await axios.post(
        `${AssesmentUrl}career_dev_group_toprank`,
        { group_ids: groupIds },
        { withCredentials: true },
      );

      if (res.data.status === 200 && res.data.top_users) {
        const transformed = res.data?.top_users.map((user) => {
          const groupId = user.group_id || groupIds[0];
          const groupName =
            groups.find((g) => g.id === groupId)?.title || "Unknown Group";

          return {
            key: `${groupId}_${user.user_id}`,
            rank: user.rank ?? null,
            name: user.username ?? "-",
            score: user.overall_score ?? 0,
            groupName: groupName,
            groupId: groupId,
          };
        });

        setGroupTopPerformers(transformed);
      } else {
        setGroupTopPerformers([]);
      }
    } catch (err) {
      console.error("Error fetching group top performers", err);
      message.error("Failed to fetch top performers");
      setGroupTopPerformers([]);
    } finally {
      setLoading(false);
    }
  };

  // Trigger course-specific top performers fetch when selected course changes
  // useEffect(() => {
  //   if (selectedCourse) {
  //     fetchCourseTopPerformers(selectedCourse);
  //   }
  // }, [selectedCourse]);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      // Fetch aggregated stats (summary + course analytics)
      await fetchSummaryAndAnalytics();
      // Fetch top ranked users
      await fetchTopRankedUsers();
      // Fetch employee insights
      await fetchEmployeeInsights();
      // Fetch chart data
      await fetchChartData();
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      message.error("Failed to load dashboard data");
    } finally {
      setLoading(false);
    }
  };

  // Fetch Summary + Course Analytics from Career Development APIs
  const fetchSummaryAndAnalytics = async () => {
    try {
      const [nestRes, pythonRes] = await Promise.all([
        axios.get(`${BaseUrl}career-course-mapping/dashboard-stats`, {
          withCredentials: true,
        }),
        axios.get(`${AssesmentUrl}career_dev_overall_group_count`, {
          withCredentials: true,
        }),
      ]);

      // ===== SUMMARY =====
      const stats = nestRes.data?.data || {};
      const summary = stats.summary || {};
      const analytics = stats.analytics || {};

      setSummaryData({
        totalCourses: summary.totalCourses || 0,
        totalEmployeesEnrolled: summary.totalEmployeesEnrolled || 0,
        coursesAssignedThisMonth: summary.coursesAssignedThisMonth || 0,
      });

      // ===== ANALYTICS (UI CALCULATION) =====
      const total = analytics.total ?? 0;
      const notStarted = analytics.notStarted ?? 0;
      const inProgress = analytics.inProgress ?? 0;
      const learningCompleted = analytics.learningCompleted ?? 0;
      const completed = pythonRes.data?.completed_group_count ?? 0;

      const pending = Math.max(0, total - (notStarted + completed));
      const assessmentnottaken = Math.max(0, completed - learningCompleted);

      const courseAnalyticsData = {
        total,
        notStarted,
        completed,
        inProgress,
        learningCompleted,
        assessmentnottaken,
      };

      setCourseAnalytics(courseAnalyticsData);

      // ===== PIE / DONUT CHART DATA =====
      setEmployeeStatusData([
        { name: "Completed", value: completed, color: CHART_COLORS.completed },
        { name: "In Progress", value: inProgress, color: CHART_COLORS.inProgress },
        { name: "Learning Completed", value: learningCompleted, color: CHART_COLORS.learningCompleted },
        {
          name: "Not Started",
          value: notStarted,
          color: CHART_COLORS.notStarted,
        },
      ]);
    } catch (error) {
      console.error("Error fetching career dashboard stats:", error);
      // No fallback data as requested
    }
  };

  useEffect(() => {
    if (!selectedCompletionGroup) return;

    const fetchGroupCompletionAnalytics = async () => {
      try {
        setLoadingCourseAnalytics(true);

        //  Nest backend → total & notStarted
        const nestRes = await axios.post(
          `${BaseUrl}career-course-mapping/getAnalyticsforSpecificGroup`,
          { groupId: selectedCompletionGroup },
          { withCredentials: true },
        );

        const total = nestRes.data?.data?.analytics?.total || 0;
        const notStarted = nestRes.data?.data?.analytics?.notStarted || 0;
        const inProgress = nestRes.data?.data?.analytics?.inProgress || 0;
        const learningCompleted = nestRes.data?.data?.analytics?.learningCompleted || 0;

        //  Python backend → completed
        const pythonRes = await axios.get(
          `${AssesmentUrl}career_dev_group_assessment_count`,
          { params: { group_id: selectedCompletionGroup } },
        );

        const completed = pythonRes.data?.completed_assessments ?? 0;
        // UI calculation
        // const inProgress = Math.max(total - (completed + notStarted), 0);

        // Update UI
        setCourseTotal(total);
        setCoursePieData([
          { name: "Completed", value: completed },
          { name: "In Progress", value: inProgress },
          { name: "Not Started", value: notStarted },
          { name: "Learning Completed", value: learningCompleted },
        ]);
      } catch (error) {
        console.error("Error fetching course analytics", error);
        setCoursePieData([]);
        setCourseTotal(0);
      } finally {
        setLoadingCourseAnalytics(false);
      }
    };

    fetchGroupCompletionAnalytics();
  }, [selectedCompletionGroup]);

  // Fetch Top Ranked Users from career_dev_overall_ranklist API
  const fetchTopRankedUsers = async () => {
    try {
      const res = await axios.get(`${AssesmentUrl}career_dev_overall_toprank`, {
        withCredentials: true,
      });

      console.log("Top Ranked Users Response:", res.data);

      if (res.data.status === 200 && res.data.top_users) {
        const transformedData = res.data.top_users.map((user) => ({
          key: user.user_id,
          rank: user.rank ?? null,
          name: user.username ?? "-",
          score: user.overall_score_percentage ?? 0,
        }));
        setTopPerformers(transformedData);
      }
    } catch (error) {
      console.error("Error fetching top ranked users:", error);
      setTopPerformers([]);
    }
  };

  // Fetch Employee Learning Insights
  const fetchEmployeeInsights = async () => {
    try {
      const res = await axios.get(
        `${BaseUrl}career-course-mapping/dashboard-insights`,
        { withCredentials: true },
      );

      const data = res.data?.data || {};
      setEmployeesRequiringAttention(
        Array.isArray(data.employeesRequiringAttention)
          ? data.employeesRequiringAttention
          : [],
      );
    } catch (error) {
      console.error("Error fetching employee insights:", error);
    }
  };

  // Fetch Chart Data
  const fetchChartData = async () => {
    try {
      const res = await axios.get(
        `${BaseUrl}career-course-mapping/dashboard-charts`,
        { withCredentials: true },
      );

      const data = res.data?.data || {};

      setCourseCompletionData(
        Array.isArray(data.courseCompletion) ? data.courseCompletion : [],
      );
      setCompletionTrendData(
        Array.isArray(data.completionTrends) ? data.completionTrends : [],
      );
      setCompletionStatusData(
        Array.isArray(data.courseCompletion) ? data.courseCompletion : [],
      );
      setLearningHoursByTeam(
        Array.isArray(data.learningHoursByTeam) ? data.learningHoursByTeam : [],
      );
      setCourseAssignmentsTimeline(
        Array.isArray(data.assignmentsTimeline) ? data.assignmentsTimeline : [],
      );
      setTeamGoals(Array.isArray(data.teamGoals) ? data.teamGoals : []);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  // Handler for Apply button
  const handleApplyGroupFilter = () => {
    if (!selectedTopPerformerGroup || selectedTopPerformerGroup.length === 0) {
      message.warning("Please select at least one course");
      return;
    }
    setAppliedTopPerformerGroup(selectedTopPerformerGroup);
  };

  const handleClearGroupFilter = () => {
    setSelectedTopPerformerGroup([]);
    setAppliedTopPerformerGroup([]);
    setGroupTopPerformers([]);
  };

  // Calculate percentages for course analytics
  const getTotalAnalytics = () => {
    const total =
      courseAnalytics.completed +
      courseAnalytics.inProgress +
      courseAnalytics.notStarted;
    return total || 1;
  };

  const totalAnalytics = getTotalAnalytics();

  // Top Performers Table Columns
  const topPerformersColumns = [
    {
      title: "Rank",
      dataIndex: "rank",
      key: "rank",
      width: 100,
      align: "center",
      render: (rank) => {
        if (rank === 1) {
          return (
            <span style={{ fontSize: 18 }}>
              <CrownOutlined style={{ color: "#FFD700", marginRight: 8 }} />
              <span style={{ fontWeight: 600, color: "#1a1a1a" }}>{rank}</span>
            </span>
          );
        } else if (rank === 2) {
          return (
            <span style={{ fontSize: 18 }}>
              <TrophyOutlined style={{ color: "#C0C0C0", marginRight: 8 }} />
              <span style={{ fontWeight: 600, color: "#1a1a1a" }}>{rank}</span>
            </span>
          );
        } else if (rank === 3) {
          return (
            <span style={{ fontSize: 18 }}>
              <TrophyOutlined style={{ color: "#CD7F32", marginRight: 8 }} />
              <span style={{ fontWeight: 600, color: "#1a1a1a" }}>{rank}</span>
            </span>
          );
        } else {
          return <span style={{ fontWeight: 600 }}>{rank}</span>;
        }
      },
    },
    {
      title: "User name",
      dataIndex: "name",
      key: "name",
      align: "center",
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: "Percentage",
      dataIndex: "score",
      key: "score",
      align: "center",
      render: (score) => (
        <Tag
          color={
            score >= 14 ? "success" : score >= 12 ? "processing" : "warning"
          }
        >
          {`${score}%`}
        </Tag>
      ),
    },
    // {
    //   title: "Courses Completed",
    //   dataIndex: "coursesCompleted",
    //   key: "coursesCompleted",
    //   align: "center",
    //   sorter: (a, b) => a.coursesCompleted - b.coursesCompleted,
    // },
  ];
  const topPerformersbyCourseColumns = [
    {
      title: "Rank",
      dataIndex: "rank",
      key: "rank",
      width: 100,
      align: "center",
      render: (rank) => {
        if (rank === 1) {
          return (
            <span style={{ fontSize: 18 }}>
              <CrownOutlined style={{ color: "#FFD700", marginRight: 8 }} />
              <span style={{ fontWeight: 600, color: "#1a1a1a" }}>{rank}</span>
            </span>
          );
        } else if (rank === 2) {
          return (
            <span style={{ fontSize: 18 }}>
              <TrophyOutlined style={{ color: "#C0C0C0", marginRight: 8 }} />
              <span style={{ fontWeight: 600, color: "#1a1a1a" }}>{rank}</span>
            </span>
          );
        } else if (rank === 3) {
          return (
            <span style={{ fontSize: 18 }}>
              <TrophyOutlined style={{ color: "#CD7F32", marginRight: 8 }} />
              <span style={{ fontWeight: 600, color: "#1a1a1a" }}>{rank}</span>
            </span>
          );
        } else {
          return <span style={{ fontWeight: 600 }}>{rank}</span>;
        }
      },
    },
    {
      title: "User name",
      dataIndex: "name",
      key: "name",
      align: "center",
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      align: "center",
      render: (score) => (
        <Tag
          color={
            score >= 14 ? "success" : score >= 12 ? "processing" : "warning"
          }
        >
          {score}
        </Tag>
      ),
    },
    // {
    //   title: "Courses Completed",
    //   dataIndex: "coursesCompleted",
    //   key: "coursesCompleted",
    //   align: "center",
    //   sorter: (a, b) => a.coursesCompleted - b.coursesCompleted,
    // },
  ];

  // Employees Requiring Attention Table Columns
  const attentionColumns = [
    {
      title: "Employee",
      dataIndex: "name",
      key: "name",
      width: "35%",
      render: (text, record) => (
        <div style={{ padding: "4px 0" }}>
          <div
            style={{
              fontWeight: 600,
              fontSize: 14,
              color: "#1a1a1a",
              marginBottom: 4,
            }}
          >
            {text}
          </div>
          <div
            style={{ fontSize: 12, color: "#8c8c8c", wordBreak: "break-word" }}
          >
            {record.email}
          </div>
        </div>
      ),
    },
    {
      title: "Completion Rate",
      dataIndex: "completionRate",
      key: "completionRate",
      align: "center",
      width: "25%",
      render: (rate) => (
        <div style={{ padding: "8px 0" }}>
          {rate === 0 ? (
            <div style={{ textAlign: "center" }}>
              <Tag
                color="error"
                style={{ margin: 0, padding: "4px 12px", fontSize: 12 }}
              >
                0%
              </Tag>
            </div>
          ) : (
            <Progress
              percent={rate}
              status={
                rate < 50 ? "exception" : rate < 80 ? "active" : "success"
              }
              strokeColor={
                rate < 50
                  ? CHART_COLORS.notStarted
                  : rate < 80
                    ? CHART_COLORS.pending
                    : CHART_COLORS.completed
              }
              size="small"
              format={(percent) => `${percent}%`}
            />
          )}
        </div>
      ),
    },
    {
      title: "Overdue",
      dataIndex: "overdueCourses",
      key: "overdueCourses",
      align: "center",
      width: "20%",
      render: (count) => (
        <div style={{ padding: "8px 0" }}>
          {count > 0 ? (
            <Tag
              color="error"
              icon={<WarningOutlined />}
              style={{
                margin: 0,
                padding: "4px 12px",
                fontSize: 12,
                fontWeight: 500,
                borderRadius: "4px",
              }}
            >
              {count}
            </Tag>
          ) : (
            <span style={{ color: "#8c8c8c", fontSize: 12 }}>-</span>
          )}
        </div>
      ),
    },
    {
      title: "Not Started",
      dataIndex: "notStartedMandatory",
      key: "notStartedMandatory",
      align: "center",
      width: "20%",
      render: (count) => (
        <div style={{ padding: "8px 0" }}>
          {count > 0 ? (
            <Tag
              color="warning"
              icon={<CloseCircleOutlined />}
              style={{
                margin: 0,
                padding: "4px 12px",
                fontSize: 12,
                fontWeight: 500,
                borderRadius: "4px",
              }}
            >
              {count}
            </Tag>
          ) : (
            <span style={{ color: "#8c8c8c", fontSize: 12 }}>-</span>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="career-dashboard-container">
      <Spin spinning={loading}>
        {/* Header */}
        <div className="dashboard-header">
          <h1 className="dashboard-title">
            <BookOutlined className="title-icon" />
            Career Development Dashboard
          </h1>
          {/* <div className="dashboard-filters">
            <Select
              value={timeFilter}
              onChange={setTimeFilter}
              style={{ width: 120, marginRight: 16 }}
            >
              <Option value="daily">Daily</Option>
              <Option value="weekly">Weekly</Option>
              <Option value="monthly">Monthly</Option>
            </Select>
            <RangePicker
              value={dateRange}
              onChange={setDateRange}
              format="MMM DD, YYYY"
            />
             
             
          </div> */}
        </div>

        <Row
          gutter={[16, 16]}
          className="summary-cards-row"
          style={{ marginTop: "24px" }}
        >
          <Col xs={24} sm={12} lg={8}>
            <Card className="summary-card">
              <Statistic
                title="Total Courses"
                value={summaryData.totalCourses}
                prefix={<BookOutlined />}
                valueStyle={{ color: CHART_COLORS.primary }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={8}>
            <Card className="summary-card">
              <Statistic
                title="Total Employees Enrolled"
                value={summaryData.totalEmployeesEnrolled}
                prefix={<UserOutlined />}
                valueStyle={{ color: CHART_COLORS.secondary }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={8}>
            <Card className="summary-card">
              <Statistic
                title="Courses Assigned "
                value={summaryData.coursesAssignedThisMonth}
                prefix={<CalendarOutlined />}
                valueStyle={{ color: CHART_COLORS.accent }}
              />
            </Card>
          </Col>
        </Row>

        {/* Course Analytics Section */}
        <Card className="analytics-card" title="Course Analytics">
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={8}>
              <div className="analytics-pie-container">
                {employeeStatusData.length > 0 &&
                  employeeStatusData.some((item) => item.value > 0) ? (
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={employeeStatusData.filter(
                          (item) => item.value > 0,
                        )}
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={100}
                        paddingAngle={5}
                        dataKey="value"
                        // label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                        labelLine={false}
                      >
                        {employeeStatusData
                          .filter((item) => item.value > 0)
                          .map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                entry.color || COLORS[index % COLORS.length]
                              }
                            />
                          ))}
                      </Pie>
                      <RechartsTooltip
                        formatter={(value, name) => [value, name]}
                        contentStyle={{
                          borderRadius: "8px",
                          border: "none",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        }}
                      />
                      <Legend
                        verticalAlign="bottom"
                        height={36}
                        iconType="circle"
                        wrapperStyle={{ paddingTop: "20px" }}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                ) : (
                  <Empty
                    description="No data available"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    style={{ padding: "40px 0" }}
                  />
                )}
              </div>
            </Col>
            <Col xs={24} lg={16}>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={8}>
                  <Card className="analytics-stat-card completed">
                    <CheckCircleOutlined className="stat-icon" />
                    <div className="stat-content">
                      <div className="stat-value">
                        {courseAnalytics.completed}
                      </div>
                      <div className="stat-label">Course Completed</div>
                      <div className="stat-percentage">
                        {(
                          (courseAnalytics.completed / totalAnalytics) *
                          100
                        ).toFixed(1)}
                        %
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={24} sm={8}>
                  <Card className="analytics-stat-card pending">
                    <ClockCircleOutlined className="stat-icon" />
                    <div className="stat-content">
                      <div className="stat-value">
                        {courseAnalytics.inProgress}
                      </div>
                      <div className="stat-label">In Progress</div>
                      <div className="stat-percentage">
                        {(
                          (courseAnalytics.inProgress / totalAnalytics) *
                          100
                        ).toFixed(1)}
                        %
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={24} sm={8}>
                  <Card className="analytics-stat-card not-started">
                    <CloseCircleOutlined className="stat-icon" />
                    <div className="stat-content">
                      <div className="stat-value">
                        {courseAnalytics.notStarted}
                      </div>
                      <div className="stat-label">Not Started</div>
                      <div className="stat-percentage">
                        {(
                          (courseAnalytics.notStarted / totalAnalytics) *
                          100
                        ).toFixed(1)}
                        %
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
                {/* Learning Completed */}
                <Col xs={24} sm={8}>
                  <Card className="analytics-stat-card completed">
                    <CheckCircleOutlined className="stat-icon" />
                    <div className="stat-content">
                      <div className="stat-value">
                        {courseAnalytics.learningCompleted}
                      </div>
                      <div className="stat-label">Learning Completed</div>
                      <div className="stat-percentage">
                        {(
                          (courseAnalytics.learningCompleted / totalAnalytics) *
                          100
                        ).toFixed(1)}
                        %
                      </div>
                    </div>
                  </Card>
                </Col>

                {/* Assessment Not Taken */}
                {/* <Col xs={24} sm={8}>
    <Card className="analytics-stat-card not-started">
      <FileTextOutlined className="stat-icon" />
      <div className="stat-content">
        <div className="stat-value">
          {courseAnalytics.assessmentnottaken}
        </div>
        <div className="stat-label">Assessment Not Taken</div>
        <div className="stat-percentage">
          {(
            (courseAnalytics.assessmentnottaken / totalAnalytics) *
            100
          ).toFixed(1)}
          %
        </div>
      </div>
    </Card>
  </Col> */}

                {/* Total */}
                <Col xs={24} sm={16}>
                  <Card className="analytics-stat-card total">
                    <TeamOutlined className="stat-icon" />
                    <div className="stat-content">
                      <div className="stat-value">
                        {courseAnalytics.total}
                      </div>
                      <div className="stat-label">Total</div>
                      <div className="stat-percentage">100%</div>
                    </div>
                  </Card>
                </Col>
              </Row>



            </Col>
          </Row>
        </Card>

        {/* Employee Learning Insights */}
        <Row gutter={[16, 16]} className="insights-row">
          <Col xs={24} lg={12}>
            <Card
              title={
                <span>
                  <TrophyOutlined style={{ marginRight: 8 }} />
                  Top Performers (Overall)
                </span>
              }
              className="insights-card"
            >
              <Table
                columns={topPerformersColumns}
                dataSource={topPerformers}
                pagination={false}
                size="small"
                scroll={{ x: "max-content", y: 400 }}
              />
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title={
                <span>
                  <TrophyOutlined style={{ marginRight: 8 }} />
                  Top Performers by Course
                </span>
              }
              className="insights-card"
            >
              {/* Filter Section */}
              <div
                style={{
                  marginBottom: "16px",
                  padding: "6px",
                  background: "#f5f5f5",
                  borderRadius: "8px",
                  display: "flex",
                  gap: "8px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <Select
                  placeholder="Select Course(s)"
                  mode="multiple"
                  value={selectedTopPerformerGroup}
                  onChange={setSelectedTopPerformerGroup}
                  style={{ flex: "1", minWidth: "200px" }}
                >
                  {groups.map((group) => (
                    <Select.Option key={group.id} value={group.id}>
                      {group.title || group.name || "Untitled Group"}
                    </Select.Option>
                  ))}
                </Select>
                <Button
                  type="primary"
                  onClick={handleApplyGroupFilter}
                  disabled={
                    !selectedTopPerformerGroup ||
                    selectedTopPerformerGroup.length === 0
                  }
                >
                  Apply
                </Button>
                <Button onClick={handleClearGroupFilter}>Clear</Button>
              </div>

              {/* Content Section */}
              {appliedTopPerformerGroup.length > 0 ? (
                loading ? (
                  <div style={{ textAlign: "center", padding: "40px 0" }}>
                    <Spin />
                  </div>
                ) : (
                  <div style={{ maxHeight: 500, overflowY: "auto" }}>
                    <Table
                      columns={topPerformersbyCourseColumns}
                      dataSource={groupTopPerformers}
                      pagination={false}
                      size="small"
                      scroll={{ x: "max-content", y: 400 }}
                      locale={{
                        emptyText:
                          "No top performers available for selected course(s)",
                      }}
                    />
                  </div>
                )
              ) : (
                <Empty
                  description="Please select one or more courses and click Apply to view top performers"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  style={{ padding: "40px 0" }}
                />
              )}
            </Card>
          </Col>
          {/* Course Completion Trends */}
          <Col xs={24} lg={12}>
            <Card
              title="Course Completion Trends Over Time"
              className="chart-card"
            >
              <ResponsiveContainer width="100%" height={400}>
                <LineChart data={completionTrendData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="period" />
                  <YAxis />
                  <RechartsTooltip />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="completed"
                    stroke={CHART_COLORS.completed}
                    strokeWidth={2}
                    name="Completed"
                  />
                  <Line
                    type="monotone"
                    dataKey="learningCompleted"
                    stroke={CHART_COLORS.learningCompleted}
                    strokeWidth={2}
                    name="Learning Completed"
                  />
                  <Line
                    type="monotone"
                    dataKey="inProgress"
                    stroke={CHART_COLORS.pending}
                    strokeWidth={2}
                    name="In Progress"
                  />
                  <Line
                    type="monotone"
                    dataKey="notStarted"
                    stroke={CHART_COLORS.notStarted}
                    strokeWidth={2}
                    name="Not Started"
                  />
                  <Line
                    type="monotone"
                    dataKey="total"
                    stroke={CHART_COLORS.total}
                    strokeWidth={2}
                    name="Not Started"
                  />
                </LineChart>
              </ResponsiveContainer>
            </Card>
          </Col>
          {/* Course Completion Count per Course */}
          <Col xs={24} lg={12}>
            <Card
              title="Course Completion Count per Course"
              className="chart-card"
              style={{ height: "370 px" }}
              extra={
                <Select
                  placeholder="Select Course"
                  value={selectedCompletionGroup}
                  onChange={setSelectedCompletionGroup}
                  style={{ width: 220 }}
                  allowClear
                >
                  {groups.map((group) => (
                    <Select.Option key={group.id} value={group.id}>
                      {group.title || group.name || "Untitled Group"}
                    </Select.Option>
                  ))}
                </Select>
              }
            >
              {selectedCompletionGroup ? (
                loadingCourseAnalytics ? (
                  <Spin style={{ display: "block", marginTop: 80 }} />
                ) : (
                  <>
                    <ResponsiveContainer width="100%" height={370}>
                      <PieChart>
                        <Pie
                          data={coursePieData}
                          dataKey="value"
                          nameKey="name"
                          innerRadius={70}
                          outerRadius={100}
                          label
                        >
                          {coursePieData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                [
                                  CHART_COLORS.completed,
                                  CHART_COLORS.pending,
                                  CHART_COLORS.notStarted,
                                ][index]
                              }
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                      </PieChart>
                    </ResponsiveContainer>

                    {/* Total Count */}
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: 12,
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      Total Enrollments: {courseTotal}
                    </div>
                  </>
                )
              ) : (
                <Empty
                  description="Please select a course to view completion data"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  style={{ padding: "40px 0" }}
                />
              )}
            </Card>
          </Col>
        </Row>

        {/* Charts Section */}
        <Row gutter={[16, 16]}></Row>

        {/* Learning Hours by Team & Team Goals */}
        {/* <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <Card title="Total Learning Hours by Team" className="chart-card">
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={learningHoursByTeam} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis type="number" />
                  <YAxis dataKey="team" type="category" width={100} />
                  <RechartsTooltip />
                  <Bar dataKey="hours" fill={CHART_COLORS.primary} />
                </BarChart>
              </ResponsiveContainer>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card title="Team Goals Progress" className="chart-card">
              <div className="goals-container">
                {teamGoals.map((goal, index) => (
                  <div key={index} className="goal-item">
                    <div className="goal-header">
                      <span className="goal-team">{goal.team}</span>
                      <span className="goal-stats">
                        {goal.current} / {goal.target} hrs
                      </span>
                    </div>
                    <Progress
                      percent={goal.progress}
                      status={goal.progress >= 100 ? "success" : "active"}
                      strokeColor={
                        goal.progress >= 100
                          ? CHART_COLORS.completed
                          : goal.progress >= 90
                          ? CHART_COLORS.pending
                          : CHART_COLORS.primary
                      }
                    />
                  </div>
                ))}
              </div>
            </Card>
          </Col>
        </Row> */}

        {/* Course Assignments Timeline */}
        {/* <Card title="Course Assignments Timeline" className="chart-card">
          <div className="timeline-container">
            {courseAssignmentsTimeline.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-course">{item.course}</div>
                <div className="timeline-bar">
                  <Tooltip title={`Start: ${item.startDate} | Due: ${item.dueDate}`}>
                    <div
                      className="timeline-progress"
                      style={{
                        left: `${(moment(item.startDate).diff(moment().subtract(30, "days"), "days") / 60) * 100}%`,
                        width: `${(moment(item.dueDate).diff(moment(item.startDate), "days") / 60) * 100}%`,
                      }}
                    />
                  </Tooltip>
                </div>
                <div className="timeline-assignments">{item.assignments} assignments</div>
              </div>
            ))}
          </div>
        </Card> */}
      </Spin>
    </div>
  );
};

export default CareerDevelopmentDashboard;
